import React from 'react';
import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope, CommodityAssignee } from '@bechtel/types';

export function useRodRoomPermissions(commodityAssignees?: CommodityAssignee[]) {
  const { user, hasPermissionScope } = useAppUser();
  const isWeldOwner =
    commodityAssignees && commodityAssignees.length > 0 && user.id
      ? commodityAssignees.some((commodityAssignees) => commodityAssignees?.assignee?.id === user.id)
      : false;
  const rodRoomPermisisons = React.useMemo(() => {
    const hasRodRequestPermissionScope = (permission: AuthPermission) =>
      (isWeldOwner && hasPermissionScope({ permission: permission, scope: AuthScope.MY_COMMODITIES })) ||
      hasPermissionScope({ permission: permission, scope: AuthScope.ALL_COMMODITIES });

    return {
      canViewRodRoom: hasPermissionScope({
        permission: AuthPermission.VIEW_ROD_ROOM,
        scope: AuthScope.APPLICATION,
      }),
      canCreateRodRequest: hasRodRequestPermissionScope(AuthPermission.CREATE_ROD_REQUEST),
      canUpdateRodRequest: hasRodRequestPermissionScope(AuthPermission.UPDATE_ROD_REQUEST),
      canDeleteRodRequest: hasRodRequestPermissionScope(AuthPermission.DELETE_ROD_REQUEST),
      canCloseRodRequest: hasPermissionScope({
        permission: AuthPermission.CLOSE_ROD_REQUEST,
        scope: AuthScope.YES,
      }),
      canIssueCaddies: hasPermissionScope({
        permission: AuthPermission.ISSUE_CADDIES,
        scope: AuthScope.YES,
      }),
      canUpdateCaddy: hasPermissionScope({
        permission: AuthPermission.UPDATE_CADDY,
        scope: AuthScope.YES,
      }),
      canReturnCaddies: hasPermissionScope({
        permission: AuthPermission.RETURN_CADDIES,
        scope: AuthScope.YES,
      }),
      canDeleteCaddy: hasPermissionScope({
        permission: AuthPermission.DELETE_CADDY,
        scope: AuthScope.YES,
      }),
      canCreateAdhocRodRequest: hasPermissionScope({
        permission: AuthPermission.CREATE_ROD_REQUEST_CADDY,
        scope: AuthScope.YES,
      }),
    };
  }, [hasPermissionScope, isWeldOwner]);
  return rodRoomPermisisons;
}
